import React, { useState } from "react";
import "../css/Affiliate.css";

import ThreeMLogo from "../Image/3Mlogo.svg";

const affiliates = [
  {
    id: 1,
    name: "3M",
    logo: ThreeMLogo,
    website: "https://www.3m.co.kr/3M/ko_KR/company-kr/",
    description: "건강 관리 데이터를 자동화기업.",
  },
  {
    id: 2,
    name: "삼성전자",
    logo: "/images/samsung_logo.png",
    website: "https://www.samsung.com/",
    description: "전자제품 제조 및 글로벌 IT 기업.",
  },
  {
    id: 3,
    name: "LG전자",
    logo: "/images/lg_logo.png",
    website: "https://www.lge.co.kr/",
    description: "전자제품 제조를 선도하는 글로벌 기업.",
  },
  {
    id: 4,
    name: "네이버",
    logo: "/images/naver_logo.png",
    website: "https://www.naver.com/",
    description: "한국 최대의 포털 사이트 운영 기업.",
  },
  {
    id: 5,
    name: "카카오",
    logo: "/images/kakao_logo.png",
    website: "https://www.kakao.com/",
    description: "메신저와 다양한 서비스를 제공하는 IT 기업.",
  },
  {
    id: 6,
    name: "현대자동차",
    logo: "/images/hyundai_motor_logo.png",
    website: "https://www.hyundai.com/",
    description: "자동차 제조업체로 세계적인 영향력을 발휘.",
  },
  {
    id: 7,
    name: "기아자동차",
    logo: "/images/kia_logo.png",
    website: "https://www.kia.com/",
    description: "혁신적인 자동차 기술을 선보이는 글로벌 기업.",
  },
  {
    id: 8,
    name: "SK하이닉스",
    logo: "/images/skhynix_logo.png",
    website: "https://www.skhynix.com/",
    description: "반도체 분야에서 글로벌 리더.",
  },
];

const Affiliate = () => {
  // 음식점 소개의 페이지네이션 상태
  const [currentPageFood, setCurrentPageFood] = useState(1);
  const affiliatesPerPageFood = 5;
  const totalPagesFood = Math.ceil(affiliates.length / affiliatesPerPageFood);

  const indexOfLastAffiliateFood = currentPageFood * affiliatesPerPageFood;
  const indexOfFirstAffiliateFood =
    indexOfLastAffiliateFood - affiliatesPerPageFood;
  const currentAffiliatesFood = affiliates.slice(
    indexOfFirstAffiliateFood,
    indexOfLastAffiliateFood
  );

  // 제휴사 소개의 페이지네이션 상태
  const [currentPageAffiliate, setCurrentPageAffiliate] = useState(1);
  const affiliatesPerPageAffiliate = 5;
  const totalPagesAffiliate = Math.ceil(
    affiliates.length / affiliatesPerPageAffiliate
  );

  const indexOfLastAffiliateAffiliate =
    currentPageAffiliate * affiliatesPerPageAffiliate;
  const indexOfFirstAffiliateAffiliate =
    indexOfLastAffiliateAffiliate - affiliatesPerPageAffiliate;
  const currentAffiliatesAffiliate = affiliates.slice(
    indexOfFirstAffiliateAffiliate,
    indexOfLastAffiliateAffiliate
  );

  // 페이지네이션 함수
  const paginateFood = (pageNumber) => {
    setCurrentPageFood(pageNumber);
  };

  const paginateAffiliate = (pageNumber) => {
    setCurrentPageAffiliate(pageNumber);
  };

  return (
    <div>
      {/* 음식점 소개 섹션 */}
      <div className="affiliate-container">
        <h1>음식점 소개</h1>
        <div className="affiliate-list">
          {currentAffiliatesFood.map((affiliate) => (
            <div key={affiliate.id} className="affiliate-card">
              <img
                src={affiliate.logo}
                alt={`${affiliate.name} 로고`}
                className="affiliate-logo"
              />
              <h2>{affiliate.name}</h2>
              <p>{affiliate.description}</p>
              <a
                href={affiliate.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                공식 웹사이트 방문
              </a>
            </div>
          ))}
        </div>

        {/* 음식점 소개의 페이지네이션 버튼 */}
        <div className="pagination">
          {Array.from({ length: totalPagesFood }, (_, index) => index + 1).map(
            (number) => (
              <button
                key={number}
                onClick={() => paginateFood(number)}
                className={`pagination-button ${
                  currentPageFood === number ? "active" : ""
                }`}
              >
                {number}
              </button>
            )
          )}
        </div>
      </div>

      {/* 제휴사 소개 섹션 */}
      <div className="affiliate-container">
        <h1>제휴사 소개</h1>
        <div className="affiliate-list">
          {currentAffiliatesAffiliate.map((affiliate) => (
            <div key={affiliate.id} className="affiliate-card">
              <img
                src={affiliate.logo}
                alt={`${affiliate.name} 로고`}
                className="affiliate-logo"
              />
              <h2>{affiliate.name}</h2>
              <p>{affiliate.description}</p>
              <a
                href={affiliate.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                공식 웹사이트 방문
              </a>
            </div>
          ))}
        </div>

        {/* 제휴사 소개의 페이지네이션 버튼 */}
        <div className="pagination">
          {Array.from(
            { length: totalPagesAffiliate },
            (_, index) => index + 1
          ).map((number) => (
            <button
              key={number}
              onClick={() => paginateAffiliate(number)}
              className={`pagination-button ${
                currentPageAffiliate === number ? "active" : ""
              }`}
            >
              {number}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Affiliate;
